<template>
  <section
    class="regulations-navigation max-w-[360px] overflow-hidden "
    aria-label="Regulation search and navigation"
    >
    <p class="text-sm text-gray-500">Alpha version - this is a work in progress, please use and report any issues.</p>
  <div class="mr-2 flex flex-row mt-4 ml-4 items-center gap-2">
    <h1 class="text-lg font-bold text-primary">CS-{{ regs.state.partNumber }} (ALPHA)</h1>
      <span class="flex-grow"></span>
      <p class="text-xs text-gray-500">
        {{ regs.state.searchTotal.toLocaleString() }} sections
        <span v-if="regs.state.searchLoading" class="ml-1 text-primary">Loading...</span>
      </p>

 
  </div>
    <div class="flex flex-col px-2  ">

      <div class="w-full flex flex-row ">
        <Dropdown
          label="Amendment"
          :options="amendmentOptions"
          :value="regs.state.amendmentNumber"
          @update:modelValue="navigateAmendment"
        />
        <div class="min-w-[90px] grid grid-cols-2 gap-1 pb-1">
          <button v-for="type in ALL_TYPES" :key="type" type="button" :class="typeButtonClass(type)"
            @click="toggleType(type)">
            {{ TYPE_LABELS[type] }}
          </button>
        </div>
      </div>

      <form class="flex min-w-0 flex-4 items-center gap-2" @submit.prevent="commitSearch">
        <Input
          v-model="queryDraft"
          type="search"
          label="Search"
          placeholder="Stall warning, fuel system..."
          class="min-w-0 flex-1"
        >
        
        <button type="submit" class="primary !m-0 flex-none" >
          Search
        </button>
        </Input>
      </form>
      </div>
      <div class="flex flex-col gap-2 px-4 pb-2 lg:flex-row lg:flex-wrap lg:items-center">

      

      <!-- <div class="flex flex-row items-center gap-2 pb-2 w-full">
        <span class="flex-grow"></span>
        <p class="text-xs text-gray-500">
          {{ regs.state.searchTotal.toLocaleString() }} sections
          <span v-if="regs.state.searchLoading" class="ml-1 text-primary">Loading...</span>
        </p>
        <button
          v-if="regs.state.searchResults.length"
          type="button"
          class="!m-0 inline-flex items-center gap-1 !rounded !border !border-gray-200 !bg-white !px-2 !py-1 !text-xs !font-bold !text-primary"
          :aria-expanded="resultsOpen"
          aria-controls="regulation-search-results"
          @click="resultsOpen = !resultsOpen"
        >
          <font-awesome-icon :icon="resultsOpen ? 'chevron-up' : 'chevron-down'" />
          {{ resultsOpen ? "Hide results" : "Show results" }}
        </button>
      </div> -->
    </div>

    <p v-if="regs.state.searchError" class="mx-4 mb-3 rounded border border-red-200 bg-red-50 p-2 text-xs text-red-700">
      {{ regs.state.searchError }}
    </p>
    {{ regs.state.searchResults.length }} {{ resultsOpen }}
    <nav
      v-show="resultsOpen && regs.state.searchResults.length"
      id="regulation-search-results"
      class="flex overflow-y-auto border-t border-gray-100 bg-gray-50 p-2 flex-col"
      aria-label="Regulation search results"
      @scroll.passive="onScroll"
    >
      <RouterLink
        v-for="section in regs.state.searchResults"
        :key="section.versionId"
        :to="sectionRoute(section.versionId)"
        :class="[
          'mb-1 flex w-full items-start gap-2 rounded border p-2 text-left transition',
          regs.state.selectedVersionId === section.versionId
            ? 'border-primary bg-blue-50'
            : 'border-transparent hover:bg-gray-50',
        ]"
      >
        <span :class="typeBadgeClass(section.type)">{{ TYPE_LABELS[section.type] || section.type }}</span>
        <span class="min-w-0">
          <span class="block text-xs font-bold leading-tight text-primary">{{ section.canonicalRef }}</span>
          <span class="block text-xs leading-snug text-gray-600">{{ shortTitle(section.title) }}</span>
        </span>
      </RouterLink>

      <button
        v-if="regs.hasMore.value && !regs.state.searchLoading"
        type="button"
        class="!m-0 w-full !py-2 text-xs !text-primary md:col-span-2 xl:col-span-3"
        @click="regs.loadMore()"
      >
        Load more
      </button>
    </nav>
  </section>
</template>

<script setup>
import { computed, ref, watch } from "vue";
import { RouterLink, useRoute, useRouter } from "vue-router";

import { Dropdown, Input } from "@comp/index.js";
import { ALL_TYPES, useRegulationsState } from "../state.js";

const TYPE_LABELS = { cs: "CS", amc: "AMC", gm: "GM", appendix: "App" };
const regs = useRegulationsState();
const route = useRoute();
const router = useRouter();
const queryDraft = ref(regs.state.searchQuery);
const resultsOpen = ref(!regs.state.selectedVersionId);

watch(
  () => regs.state.selectedVersionId,
  (versionId) => {
    // if (versionId) resultsOpen.value = false;
  },
  { immediate: true }
);

const amendmentOptions = computed(() => Array.from(
  { length: Number(route.meta.latestAmendment) + 1 },
  (_, index) => {
    const value = Number(route.meta.latestAmendment) - index;
    return {
      id: value,
      value,
      label: `A${String(value).padStart(2, "0")}${value === Number(route.meta.latestAmendment) ? " (latest)" : ""}`,
    };
  }
));

function sectionRoute(versionId) {
  return {
    name: route.name,
    query: {
      amendment: String(regs.state.amendmentNumber),
      versionId,
    },
  };
}

function navigateAmendment(amendment) {
  resultsOpen.value = true;
  router.push({
    name: route.name,
    query: { amendment: String(amendment) },
  });
}

function commitSearch() {
  resultsOpen.value = true;
  return regs.setQuery(queryDraft.value);
}

function toggleType(type) {
  resultsOpen.value = true;
  return regs.toggleType(type);
}

function typeButtonClass(type) {
  const active = regs.state.activeTypes.includes(type);
  return [
    "!m-0 !rounded !border !px-2 !py-1 !text-xs !font-bold",
    active ? typeBadgeClass(type) : "border-gray-200 bg-white text-gray-400",
  ];
}

function typeBadgeClass(type) {
  const colors = {
    cs: "border-blue-200 bg-blue-100 text-blue-700",
    amc: "border-green-200 bg-green-100 text-green-700",
    gm: "border-yellow-300 bg-yellow-100 text-gray-800",
    appendix: "border-orange-200 bg-orange-100 text-orange-700",
  };
  return `flex-none rounded border px-1.5 py-0.5 text-xs font-bold ${colors[type] || "border-gray-200 bg-gray-100 text-gray-600"}`;
}

function shortTitle(title) {
  const clean = String(title || "").replace(/^(CS|AMC|GM|App)\s+[\d.]+\s*[-\u2013]\s*/i, "");
  return clean.length > 70 ? `${clean.slice(0, 67)}...` : clean;
}

function onScroll(event) {
  const element = event.target;
  if (element.scrollHeight - element.scrollTop - element.clientHeight < 80) {
    regs.loadMore();
  }
}
</script>
